import type { ElementTag } from './element/types';

// Tracking remains opt-in; adding a renderer must not automatically enable analytics.
const COMPONENT_TYPE_BY_TAG: {
	readonly 'action-card': 'actionCard';
	readonly 'inferred-project': 'inferredProject';
	readonly 'people-entity': 'peopleEntity';
	readonly 'people-entity-list': 'peopleEntityList';
	readonly 'smart-link': 'smartLink';
	readonly 'smart-link-list': 'smartLinkList';
} = {
	'action-card': 'actionCard',
	'inferred-project': 'inferredProject',
	'people-entity': 'peopleEntity',
	'people-entity-list': 'peopleEntityList',
	'smart-link': 'smartLink',
	'smart-link-list': 'smartLinkList',
} as const satisfies Partial<Record<ElementTag, string>>;

const LINK_EMBED_COMPONENT_TYPE = 'linkEmbed';

export type LuminaViewComponentType =
	| (typeof COMPONENT_TYPE_BY_TAG)[keyof typeof COMPONENT_TYPE_BY_TAG]
	| typeof LINK_EMBED_COMPONENT_TYPE;

const isTrackedTag = (tag: string): tag is keyof typeof COMPONENT_TYPE_BY_TAG =>
	Object.prototype.hasOwnProperty.call(COMPONENT_TYPE_BY_TAG, tag);

export const getLuminaViewComponentType = (
	tag: string,
	smartLinkRenderer?: 'embed',
): LuminaViewComponentType | undefined => {
	if (tag === 'smart-link' && smartLinkRenderer === 'embed') {
		return LINK_EMBED_COMPONENT_TYPE;
	}
	return isTrackedTag(tag) ? COMPONENT_TYPE_BY_TAG[tag] : undefined;
};
